'use client'

import { ComponentProps, FC, PropsWithChildren } from 'react'
import styled from 'styled-components'

import { MediaAsContents, focusOutline } from '@syconium/little-miss-figgy'

type MediaSize = 'sm' | 'md' | 'lg'

type GreaterThanProps = {
  greaterThanOrEqual: MediaSize
  lessThan?: never
}

type LessThanProps = {
  greaterThanOrEqual?: never
  lessThan: MediaSize
}

type Props = PropsWithChildren<(GreaterThanProps | LessThanProps) & ComponentProps<'button'>>

const UnstyledButton = styled.button`
  text-align: unset;
  padding: 0px;
  margin: 0px;
  border: 0px;
  border-radius: 0px;
  padding-inline: 0px;
  padding-block: 0px;
  ${focusOutline};
`

export const ButtonWhen: FC<Props> = ({
  children,
  greaterThanOrEqual,
  lessThan,
  type = 'button',
  ...rest
}) => {
  const buttonCondition = greaterThanOrEqual ? { greaterThanOrEqual } : { lessThan }
  const oppositeCondition = greaterThanOrEqual
    ? { lessThan: greaterThanOrEqual }
    : { greaterThanOrEqual: lessThan }

  return (
    <>
      <MediaAsContents {...buttonCondition}>
        <UnstyledButton type={type} {...rest}>
          {children}
        </UnstyledButton>
      </MediaAsContents>
      <MediaAsContents {...oppositeCondition}>{children}</MediaAsContents>
    </>
  )
}
